if (window._subiz_init_2094850928430) {
	throw new Error('subiz have already initialized')
}
window._subiz_init_2094850928430 = true

var apiV2 = {}
window.apiV2 = apiV2

import axios from 'axios'
const objectPath = require('object-path')
import { cookie } from 'cookie_js'
import storage from './storage.js'
cookie.defaults.path = '/'

function clearBrowserData () {
	const cookies = cookie.all() || {}
	for (var k in cookies) {
		if (cookies.hasOwnProperty(k)) {
			if ((k || '').startsWith('__sb')) cookie.remove(k)
		}
	}

	storage.clear()
}

import { Server, Client } from './client_server.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.withCredentials = false
// axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.timeout = 60 * 1000

// disable xsrf cookie to avoid preflight request
// (if xsrf cookie exist -> axios set header X-XSRF-TOKEN -> preflight request)
axios.defaults.xsrfCookieName = null

axios.defaults.transformRequest.push((data, headers) => {
	if (data) headers['Content-Type'] = 'text/plain'
	return data
})

// Add a response interceptor
axios.interceptors.response.use(
	response => {
		const errorCode = objectPath.get(response, 'data.error', '')
		if (!errorCode) return response

		_callV4('_emit', 'api.error', errorCode)
		return response
	},
	error => {
		const errorCode = objectPath.get(error, 'response.data.error', '')
		if (!errorCode) return Promise.reject(error)

		_callV4('_emit', 'api.error', errorCode)
		return Promise.reject(error)
	},
)

function hasGA () {
	return !!(window.ga && window.ga.getAll)
}

function getGaClientId () {
	var clientId = ''
	if (!hasGA()) return clientId

	var allTrackers = window.ga.getAll() || []
	allTrackers.forEach(function (tracker) {
		clientId = tracker.get('clientId')
	})

	return clientId
}

function getGaTrackingIds () {
	var trackingIds = []
	if (!hasGA()) return trackingIds

	const allTrackers = window.ga.getAll() || []
	allTrackers.forEach(function (tracker) {
		var trackingId = tracker.get('trackingId')
		if (trackingId) {
			trackingIds.push(trackingId)
		}
	})

	return trackingIds
}

function getDeviceInfo () {
	return {
		user_agent: window.navigator.userAgent,
		screen_resolution: window.screen.width + 'x' + window.screen.height,
		source_referrer: document.referrer,
		ga_client_id: getGaClientId(),
		ga_tracking_ids: getGaTrackingIds(),
		language: navigator.language || navigator.userLanguage,
	}
}

function size (o) {
	if (!o) return 0
	if (o.length !== undefined) return o.length
	return Object.keys(o).length
}

function isEmpty (o) {
	if (!o) return true
	for (var k in o) if (o.hasOwnProperty(k)) return false
	return true
}

// === LIB ===
function isV4 () {
	var scripts = document.getElementsByTagName('script')
	if (!window._sbzq && typeof window.subiz !== 'function') return false

	for (var s in scripts) {
		if (!scripts[s] || !scripts[s].src) continue
		if (scripts[s].src.indexOf(process.env.VUE_APP_BASE_URL) !== -1) {
			return true
		}
	}
	return false
}

function isV2 () {
	if (!window._sbzq) return false
	var scripts = document.getElementsByTagName('script')
	for (var s in scripts) {
		if (!scripts[s] || !scripts[s].src) continue
		if (scripts[s].src.indexOf('static.subiz.com') !== -1) return true
	}
	return false
}

function isV1 () {
	return window.subiz_account_id && window.subiz_account_id > 0
}

export const sendToGA = (category, action, label) => {
	if (!hasGA()) return

	const allTrackers = window.ga.getAll() || []
	allTrackers.forEach(tracker => {
		const name = tracker.get('name')
		window.ga(name + '.send', 'event', category, action, label)
	})
}

export const sendToFBPixel = (category, action, label) => {
	if (!window.fbq) return

	window.fbq('trackCustom', category, { action: action, label: label })
}

let g_last_dev // last device
const _gaInterval = setInterval(() => {
	var dev = getDeviceInfo()

	if (JSON.stringify(dev) === JSON.stringify(g_last_dev)) return
	g_last_dev = dev
	if (dev.ga_tracking_ids && dev.ga_client_id) clearInterval(_gaInterval)
	_callV4('_setDevice', dev)
}, 2000)

function _sbz_v2 (args) {
	if (size(args) < 1) return
	var method = args.shift()
	if (typeof apiV2[method] !== 'function') return
	apiV2[method](size(args) > 0 ? args[0] : undefined)
}

apiV2._setAccount = id => _callV4('setAccount', id)

apiV2.setLanguage = code => _callV4('setLanguage', code)

apiV2.setInfo = info => {
	var attributes = []

	if (!isEmpty(info.name)) {
		attributes.push({ key: 'fullname', text: info.name })
	}

	if (!isEmpty(info.email)) {
		attributes.push({ key: 'emails', text: info.email })
	}

	if (!isEmpty(info.phone)) {
		attributes.push({ key: 'phones', text: info.phone })
	}

	if (isEmpty(attributes)) return

	_callV4('updateUserAttributes', attributes)
}

apiV2.getInfo = () => {} // incompatible

apiV2.expandWidget = _ => _callV4('expandWidget')

apiV2.shrinkWidget = _ => _callV4('shrinkWidget')

apiV2.getVisitorId = () => {} // incompatible

// === END LIB ===

window.addEventListener('resize', () =>
	_callV4('_resize', document.documentElement.clientHeight, document.documentElement.clientWidth),
)

new Server('widget_4_parent', {
	version: () => '234',
	set_local_storage: (key, value, ttl) => storage.set(key, value, ttl),
	remove_local_storage: key => storage.remove(key),
	clear_local_storage: () => storage.clear(),
	get_local_storage: (key, def_value) => storage.get(key, def_value),
	clear_browser_data: clearBrowserData,
	call_v4: (...args) => _callV4(...args),
	set_style: style => {
		for (var name in style) iframe.style[name] = style[name]
	},

	track_fb: (category, action, label) => sendToFBPixel(category, action, label),

	track_ga: (category, action, label) => sendToGA(category, action, label),

	fetch: (method, path, body, options) => axios[method](path, body, options),

	initapi: async () => {
		// backward compatible api
		if (isV1()) {
			var accountId = window.subiz_account_id || ''
			apiV2._setAccount(accountId)
		} else if (isV2()) {
			var queue = window._sbzq || []
			window._sbzq = { push: _sbz_v2 }
			queue.forEach(_sbz_v2)
		} else if (isV4()) {
			if (window._sbzq instanceof Array) {
				var queue = window._sbzq || []
				window._sbzq = {
					push: function (i) {
						_callV4.apply(null, i)
					},
				}
				queue.forEach(function (i) {
					_callV4.apply(null, i)
				})
			}

			if (typeof window.subiz === 'function') {
				var queue = window.subiz.q || []
				window.subiz = _callV4
				queue.forEach(function (i) {
					_callV4.apply(null, i)
				})
			}
		} else {
			console.log('cannot detect embed code version')
		}

		var uid = cookie.get('__sbid', '')
		var mask = cookie.get('__sbmask', '')
		var out = await _callV4('_init', document.title, location.href, mask, uid)

		if (uid !== out.user_id || mask !== out.user_mask) {
			cookie.set('__sbid', out.user_id, { expires: 365 })
			cookie.set('__sbmask', out.user_mask, { expires: 365 })
		}

		var doc_ele = document.documentElement
		_callV4('_resize', doc_ele.clientHeight, doc_ele.clientWidth)

		// make sure resized
		setTimeout(() => _callV4('_resize', doc_ele.clientHeight, doc_ele.clientWidth), 2000)
	},
})

var IFRAME_ID = 'subiziframe12230948092348092384'
var iframe = document.createElement('iframe')
iframe.setAttribute('src', `${process.env.VUE_APP_BASE_URL}/${process.env.VUE_APP_HASH}.iframe.html`)
iframe.setAttribute('scrolling', 'yes')
iframe.id = IFRAME_ID
iframe.style.display = 'none'
iframe.style.margin = '0px'
iframe.style.padding = '0px'
iframe.style.border = '0px'
iframe.style['background-color'] = 'rgba(0, 0, 0, 0)'
iframe.style['z-index'] = 2147483640
iframe.style.position = 'fixed'
iframe.style.bottom = '0px'
iframe.style.overflow = 'hidden'
iframe.style.right = '0px'
iframe.style.width = '100%'
iframe.style.height = '100%'
iframe.style.transition = 'all'
document.body.appendChild(iframe)

let g_iframe = new Client('widget_4_iframe', iframe.contentWindow)

async function _callV4 () {
	// remove the cb parameter out of param
	let args = Array.prototype.slice.call(arguments)
	let out = await g_iframe.call(...args)
	if (size(args) > 0 && typeof args[size(args) - 1] === 'function') {
		args[size(args) - 1](out)
	}
	return out
}
